export enum PhoneSetting {
  /** Phone numbers are required. */
  Required = "required",
  /** Phone numbers are optional. They can be accessed, and can be skipped. */
  Optional = "optional",
  /** Phone numbers are disabled. Users should not be able to provide one. */
  Disabled = "disabled",
}
